<template>
  <div :style="{height: height + 'px'}" class="d-flex justify-content-center align-items-center">
    <div class="loading">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: "LoadingBox",
  props: {
    height: {
      default: 470,
      type: Number,
      required: false
    },
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
body {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  background: #222;
}

.loading {
  $colors: #E79C10,#FF5B5C, #E79C10,#FF5B5C,#1d9099;
  display: flex;

  .dot {
    position: relative;
    width: 1.5em;
    height: 1.5em;
    margin: 0.8em;
    border-radius: 50%;

    &::before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      background: inherit;
      border-radius: inherit;
      animation: wave 2s ease-out infinite;
    }

    @for $i from 1 through 5 {
      &:nth-child(#{$i}) {
        background: nth($colors, $i);

        &::before {
          animation-delay: $i * 0.2s;
        }
      }
    }
  }
}

@keyframes wave {
  50%,
  75% {
    transform: scale(2.5);
  }

  80%,
  100% {
    opacity: 0;
  }
}


</style>
